var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconTypingAnEmailYwbvz6Xk2L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.3 218.2",
    style: {
      enableBackground: "new 0 0 217.3 218.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#F9F1E1;}\n\t.st3{fill:#EAF4FE;}\n\t.st4{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-miterlimit:10;}\n\t.st5{fill:#0561FC;}\n\t.st6{fill:#C5E1F9;}\n\t.st7{fill:#7EB3FF;}\n\t.st8{fill:#B5D5EA;}\n\t.st9{fill:#E1EBF4;}\n\t.st10{fill:#9AC7F7;}\n\t.st11{fill:none;stroke:#0561FC;stroke-width:6.8376;}\n\t.st12{fill:none;stroke:#7EB3FF;stroke-width:6.8376;}\n\t.st13{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;}\n\t.st14{fill:none;stroke:#0561FC;stroke-width:7.1001;}\n\t.st15{fill:#B6D9EF;}\n\t.st16{fill:none;stroke:#9AC7F7;stroke-width:6.8376;}\n\t.st17{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linejoin:bevel;}\n\t.st18{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;stroke-linejoin:round;}\n\t.st19{fill:none;stroke:#0561FC;stroke-width:5.0237;}\n\t.st20{fill:none;stroke:#0450CF;stroke-width:6.8376;}\n\t.st21{fill:none;stroke:#C5E1F9;stroke-width:6.8376;}\n\t.st22{fill:#FFBF0D;}\n\t.st23{fill:#B2D2EA;}\n\t.st24{fill:none;stroke:#0561FC;stroke-width:6.9311;}\n\t.st25{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st26{fill:#FFFFFF;}\n\t.st27{fill:#FFFFFF;stroke:#0561FC;stroke-width:6.8376;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.7,
    y: -8,
    className: "st2",
    width: 218.8,
    height: 218.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "94.2,115.7 111.3,115.7 142.1,139.6 142.1,115.7 166,115.7 166,2.8 1.9,2.8 1.9,115.7 12.2,115.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 83.9,
    y1: 173.8,
    x2: 90.7,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 97.6,
    y1: 173.8,
    x2: 104.4,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 111.3,
    y1: 173.8,
    x2: 118.1,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 125,
    y1: 173.8,
    x2: 131.7,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 138.6,
    y1: 173.8,
    x2: 145.4,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 152.3,
    y1: 173.8,
    x2: 159.1,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 166,
    y1: 173.8,
    x2: 172.8,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 179.7,
    y1: 173.8,
    x2: 186.4,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 193.3,
    y1: 173.8,
    x2: 200.1,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 83.9,
    y1: 187.5,
    x2: 90.7,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 97.6,
    y1: 187.5,
    x2: 104.4,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 111.3,
    y1: 187.5,
    x2: 118.1,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 125,
    y1: 187.5,
    x2: 131.7,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 138.6,
    y1: 187.5,
    x2: 145.4,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 152.3,
    y1: 187.5,
    x2: 159.1,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 166,
    y1: 187.5,
    x2: 172.8,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 179.7,
    y1: 187.5,
    x2: 186.4,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 183,
    y1: 187.5,
    x2: 200.1,
    y2: 187.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 83.9,
    y1: 201.1,
    x2: 90.7,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 97.6,
    y1: 201.1,
    x2: 155.7,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 111.2,
    y1: 201.1,
    x2: 118.1,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 124.9,
    y1: 201.1,
    x2: 131.7,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 138.6,
    y1: 201.1,
    x2: 145.4,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 152.2,
    y1: 201.1,
    x2: 159.1,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 166,
    y1: 201.1,
    x2: 172.8,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 179.7,
    y1: 201.1,
    x2: 186.4,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 193.3,
    y1: 201.1,
    x2: 200.1,
    y2: 201.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.7,
    y: 156.7,
    className: "st11",
    width: 136.6,
    height: 58.1
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "1.9,2.8 83.9,57.5 166,2.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M75.8,132.8c-5.6,4.2-12.6,6.7-20.1,6.7c-18.4,0-33.4-15-33.4-33.4c0-18.5,15-33.4,33.4-33.4 c10.4,0,19.7,4.8,25.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66.2,90.6c0,0-13.7-3.1-21.7,4.3c-9.6,9-7.5,23,1.4,25.5c8.8,2.5,12.1-4.2,13.2-7.2 C60.2,110.3,66.2,90.6,66.2,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.2,94c0,0-5.9,20.6-1.8,24.3c11.9,10.8,39.4-17.3,12.6-38.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M193.3,13.1v46.7c0,6.3,3.9,11.4,10.3,11.4l0,0c6.3,0,10.3-5.1,10.3-11.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 179.7,
    y1: 34,
    x2: 207,
    y2: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M22.4,218.2v-46.7c0-6.3,3.9-11.4,10.3-11.4l0,0c6.3,0,10.3,5.1,10.3,11.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 8.7,
    y1: 184,
    x2: 36.1,
    y2: 184
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconTypingAnEmailYwbvz6Xk2L);
export default __webpack_public_path__ + "static/media/reshot-icon-typing-an-email-YWBVZ6XK2L.0bd107cbdb39f5cdc6c1ed6ee22c417a.svg";
export { ForwardRef as ReactComponent };